import * as React from 'react';
import { useTheme } from '../theme/use-theme';
export var CheckboxCheckedIcon = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 18 : _b, _c = _a.color, color = _c === void 0 ? 'currentColor' : _c;
    var innerSize = typeof size === 'number' ? size - 4 : size;
    return (React.createElement("svg", { width: size, height: size, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("rect", { width: size, height: size, rx: "4", fill: color }),
        React.createElement("rect", { x: "2", y: "2", width: innerSize, height: innerSize, rx: "2", fill: color }),
        React.createElement("path", { d: "M13.6666 6.0835L7.24992 12.5002L4.33325 9.5835", stroke: "white", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })));
};
export var CheckboxIcon = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 18 : _b, _c = _a.color, color = _c === void 0 ? 'currentColor' : _c;
    var theme = useTheme();
    var innerSize = typeof size === 'number' ? size - 4 : size;
    return (React.createElement("svg", { width: size, height: size, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("rect", { width: size, height: size, rx: "4", fill: color }),
        React.createElement("rect", { x: "2", y: "2", width: innerSize, height: innerSize, rx: "2", fill: theme.tokens.color_bg_input })));
};
